import * as R from 'ramda';

const NOT_DISPLAYED = 'NOT_DISPLAYED';

export const getIsHidden = annotations =>
  R.pipe(R.find(R.propEq(NOT_DISPLAYED, 'type')), R.complement(R.isNil))(annotations);

export const getFullName = R.identity;
